import debounce from 'lodash/debounce';
import IntersectionObserver from 'intersection-observer-polyfill';
import { sendCustomPageEvent } from '../config/analytics';
import { calcOffsetBoxesSizeWithoutHeaderOffer } from '../utils/offsetBoxes';
import '../domPolyfills/closest';

const ACTIVE_ATTR = `data-active`;

export function initAnchorNavigation(
  NAV_PARENT_ATTR,
  NAV_ITEM_ATTR,
  intersectionThreshold,
  intersectionRatio,
  isMainNavVisibleOnScrollUp = false
) {
  const getTargetFrom = (item) => item.getAttribute(NAV_ITEM_ATTR) || null;

  const subNavItemsList =
    Array.from(document.querySelectorAll(`[${NAV_ITEM_ATTR}]`)).filter(
      Boolean
    ) || [];

  const subNavTargetsSelectorsList =
    subNavItemsList.map(getTargetFrom).filter(Boolean) || [];

  let hasObserve = true;

  subNavItemsList.forEach((item) => {
    item.addEventListener('click', (event) => {
      event.preventDefault();

      sendCustomPageEvent('Sub-navgation - Icon Click');

      const targetSelector = getTargetFrom(item);

      if (targetSelector) {
        toggleActiveInList(
          subNavItemsList,
          targetSelector,
          NAV_PARENT_ATTR,
          NAV_ITEM_ATTR,
          ACTIVE_ATTR
        );
        goToTarget(targetSelector);
      }
    });
  });

  const observer = new IntersectionObserver(observeFn, {
    threshold: intersectionThreshold,
  });

  subNavTargetsSelectorsList
    .map((targetSelector) => document.querySelector(targetSelector))
    .filter(Boolean)
    .forEach((item) => {
      observer.observe(item);
    });

  function goToTarget(targetSelector) {
    if (!targetSelector) {
      return null;
    }

    const scrollDuration = 500; // NOTE: Hardcoded in Helpers.scrollToElement
    const targetEl = document.querySelector(targetSelector);
    const targetElOffsetTop = targetEl ? targetEl.offsetTop : 0;
    const isScrollDown = isMainNavVisibleOnScrollUp
      ? true
      : targetElOffsetTop >= window.pageYOffset;
    const targetOffset = calcOffsetBoxesSizeWithoutHeaderOffer(isScrollDown);

    window.Helpers.scrollToElement(targetSelector, -targetOffset);

    hasObserve = false;

    return debounce(() => {
      hasObserve = true;
    }, scrollDuration)();
  }

  function observeFn(entries) {
    const lastEntry = entries.pop();
    const targetValue = getRelatedTargetValue(
      lastEntry,
      subNavTargetsSelectorsList
    );

    if (hasObserve && lastEntry.intersectionRatio >= intersectionRatio) {
      if (targetValue) {
        toggleActiveInList(
          subNavItemsList,
          targetValue,
          NAV_PARENT_ATTR,
          NAV_ITEM_ATTR,
          ACTIVE_ATTR
        );
      }
    } else if (lastEntry.intersectionRatio <= 0.1) {
      if (targetValue) {
        subNavItemsList.forEach((item) => {
          if (item.getAttribute(NAV_ITEM_ATTR) === targetValue) {
            item.setAttribute(ACTIVE_ATTR, 'false');
          }
        });
      }
    }
  }
}

function getRelatedTargetValue(intersectionEntry, targetsList) {
  const relateToEntry = (selector) =>
    document.querySelector(selector) === intersectionEntry.target;

  return targetsList.find(relateToEntry);
}

function toggleActiveInList(
  nodeList = [],
  activeValue = null,
  parentAttr,
  itemAttr,
  activeAttr
) {
  if (!activeValue) {
    return;
  }

  nodeList.forEach((nodeItem) => {
    const item = nodeItem;

    if (item.getAttribute(itemAttr) === activeValue) {
      item.setAttribute(activeAttr, 'true');

      if (parentAttr) {
        // NOTE: Calculating the value to align to the center the element
        const offsetLeft =
          item.offsetLeft + item.offsetWidth / 2 - window.innerWidth / 2;

        item.closest(`[${parentAttr}]`).scrollLeft = offsetLeft;
      }
    } else {
      item.setAttribute(activeAttr, 'false');
      item.blur();
    }
  });
}
